import React from 'react';
import { lessonTheme } from './LessonCard';

const SECTION_EMOJI: [RegExp, string][] = [
  [/homework/i, '📚'],
  [/home row/i, '🏠'],
  [/top row/i, '⬆️'],
  [/bottom row/i, '⬇️'],
  [/tricky/i, '🧩'],
  [/shift/i, '🔠'],
  [/pattern/i, '🔁'],
  [/number/i, '🔢'],
  [/more symbols/i, '💫'],
  [/symbol/i, '✳️'],
  [/advanced/i, '🚀'],
  [/basic/i, '🌱'],
  [/tutorial/i, '🎒'],
];

const sectionEmoji = (title: string) => SECTION_EMOJI.find(([re]) => re.test(title))?.[1] ?? '⌨️';

interface LessonSectionHeaderProps {
  title: string;
  subtitle?: string;
  theme: number;
  done?: number;
  total?: number;
}

const LessonSectionHeader: React.FC<LessonSectionHeaderProps> = ({ title, subtitle, theme, done, total }) => {
  const t = lessonTheme(theme);
  const allDone = total !== undefined && total > 0 && done === total;
  return (
    <div className="flex flex-wrap items-center gap-3 mb-5">
      <span className={`group inline-flex w-12 h-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br ${t.tile} text-2xl shadow-md ring-4 ring-white`} aria-hidden="true">
        <span className="inline-block fun-wiggle-hover">{sectionEmoji(title)}</span>
      </span>
      <div className="min-w-0">
        <h2 className={`text-2xl md:text-3xl font-black leading-tight bg-gradient-to-r ${t.title} bg-clip-text text-transparent`}>{title}</h2>
        {subtitle && <h3 className="text-sm font-bold text-gray-500">{subtitle}</h3>}
      </div>
      {total !== undefined && total > 0 && (
        <span className={`ml-auto inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-black shadow-sm ring-2 ring-white ${allDone ? 'bg-gradient-to-r from-yellow-300 to-amber-400 text-amber-900' : 'bg-white text-gray-600'}`}>
          {allDone ? '🏆' : '⭐'} {done}/{total}
        </span>
      )}
    </div>
  );
};

export default LessonSectionHeader;
